module.exports = __webpack_public_path__ + "static/media/gem-yellow.aa90de9f.svg";